module.exports = __webpack_public_path__ + "static/media/portrait-5.ccbb35fd.jpg";